/** Escape a CSV cell and keep untrusted text from becoming a spreadsheet formula. */
export function csvCell(value: unknown): string {
  let text = value === null || value === undefined ? '' : String(value);
  // Keep actual numeric values usable for financial calculations in the export.
  const numeric = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(text);
  if (!numeric && (/^\s*[=+\-@＝＋－＠]/u.test(text) || /^[\t\r\n]/.test(text))) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Only a canonical local path can be used as the post-login destination. */
export function safeInternalRedirect(value: string | null | undefined, fallback = '/operar'): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(value)) return fallback;
  try {
    const base = 'https://internal.invalid';
    const url = new URL(value, base);
    const path = decodeURIComponent(url.pathname);
    if (url.origin !== base || path.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(path)) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
